import { render, staticRenderFns } from "./CheckRepetion.vue?vue&type=template&id=32647d10&scoped=true"
import script from "./CheckRepetion.vue?vue&type=script&lang=js"
export * from "./CheckRepetion.vue?vue&type=script&lang=js"
import style0 from "./CheckRepetion.vue?vue&type=style&index=0&id=32647d10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32647d10",
  null
  
)

export default component.exports